import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Port } from '../models/port';
import { MatSnackBar } from '@angular/material';
import { UserGroupItem } from '../models/user-group-item';

@Injectable({
  providedIn: 'root'
})
export class PortService {

  //portsSubject:Subject<Port>;
  ports: Port[] = [];

  constructor(private http: HttpClient, public snackBar: MatSnackBar) {
  }

  getPortsByIds(ids: number[]): Observable<Port[]> {

      return this.http.put<Port[]>('core-service/api/port/ports-by-ids', ids).pipe(
        catchError(this.handleError<any>('Ports')))


  }

  searchPortByLabel(portLabel: string, siteId?: number): Observable<[UserGroupItem]> {

    console.log("runnig get ports by site id")

    var params = new HttpParams().set('port_label', portLabel)

    if (siteId != undefined)
      params = params.set('site_id', siteId.toString())

    return this.http.get<[UserGroupItem]>('core-service/api/port/search-ports', { params: params }).pipe(
      catchError(this.handleError<any>('Ports'))
    )
  }

  xgetPortsBySiteIdDTO(site_id: number): Observable<[UserGroupItem]> {

    console.log("runnig get ports by site id")

    return this.http.get<[UserGroupItem]>('core-service/api/port/x-get-ports?site_id=' + site_id).pipe(
      catchError(this.handleError<any>('Ports'))
    )
  }

  xgetPortsBySiteId(site_id: number): Observable<[Port]> {

    console.log("runnig get ports by site id")

    return this.http.get<[Port]>('core-service/api/port?site_id=' + site_id).pipe(
      catchError(this.handleError<any>('Ports'))
    )
  }

  getPortsBySiteIdAndClassificationId(site_id: number, classification_id: number): Observable<[Port]> {

    var params = new HttpParams()
      .set("site_id", site_id.toString())
      .set("port_classification_id", classification_id.toString())

    return this.http.get<[Port]>('core-service/api/port', { params: params }).pipe(
      catchError(this.handleError<any>('Ports'))
    )
  }

  getPortsBySiteIdAndAlarmGroupId(site_id: number, alarm_group_id: number): Observable<[Port]> {

    let other:number = -1

    var params = new HttpParams()
      .set("site_id", site_id.toString())
      .set("port_alarm_group_id", alarm_group_id != null ? alarm_group_id.toString() : other.toString())

    return this.http.get<[Port]>('core-service/api/port', { params: params }).pipe(
      catchError(this.handleError<any>('Ports'))
    )
  }

  getPortsBySiteIdADevId(site_id: number, dev_id: number): Observable<[Port]> {

    var params = new HttpParams()
      .set("site_id", site_id.toString())
      .set("dev_id", dev_id.toString())

    return this.http.get<[Port]>('core-service/api/port', { params: params }).pipe(
      catchError(this.handleError<any>('Ports'))
    )
  }

  getPortBySiteId(site_id: number) {

    this.ports = [];

    this.http.get<[Port]>('core-service/api/port?site_id=' + site_id).pipe(
      catchError(this.handleError<any>('Ports'))
    ).subscribe(res => {
      if (res) {
        this.ports = res;

      }
    })

  }

  //following is never used, get rid of eventually
  //Get ports by site
  getPortBySiteIdAndAlarmGroup(site_id: number, port_alarm_group_id: number) {

    /*     this.ports = []; //find a better way of doing this
    
         this.http.get<[Port]>('core-service/api/port?site_id=' + site_id + '&port_alarm_group_id=' + port_alarm_group_id).pipe(
          catchError(this.handleError<any>('Ports'))
        ).subscribe( res =>{
          if(res){
            res.forEach(port => {
              if(true){
                this.portsSubject.next(port);
                
              }
            });
          }
        }) */
  }

  movePortsToClassification(classificationId: number, portsArr: Port[]): Observable<any> {

    var temp: number[] = [];
    portsArr.forEach(port => {
      temp.push(port.port_nid)
    });

    return this.http.post<any>('/core-service/api/port/classification?classification_id=' + classificationId, { port_nid: temp })

  }

  movePortsToAlarmGroup(groupId: number, portsArr: Port[], currentSiteId: number): Observable<any> {

    var temp: number[] = [];
    portsArr.forEach(port => {
      temp.push(port.port_nid)
    });

    if (!groupId)
      groupId = -1

    return this.http.post<any>('/core-service/api/port/alarm-group?group_id=' + groupId, { port_nid: temp });

  }

  getPortById(port_id: any): Observable<[Port]> {
    return this.http.get<Port>('core-service/api/port?port_nid=' + port_id).pipe(
      catchError(this.handleError<any>('Port'))
    );
  }


  editPort(newPort: Port): Observable<any> {

    return this.http.post<any>('core-service/api/port', newPort)
      .pipe(catchError(this.handleError<any>('edit port details', 'error')));
  }


  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      this.snackBar.open(`${operation} failed: ${error.message}`, '', {
        duration: 3000,
      });

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
